import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigFinishDefault, Tarea, TareaInstance, Tramite } from '@app/shared';
import { EndpointService } from '@app/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class LoadTaskDataService {

  constructor(
    private http: HttpClient,
    private api: EndpointService,
    private toastr: ToastrService
  ) { }

  getTask(idTask: number): Promise<Tarea> {
    return new Promise((resolve, reject) => {
      this.http.get<Tarea>(this.api.get('associatedTask', [idTask])).subscribe(
        data => {
          resolve(data);
        },
        err => reject(err)
      );
    });
  }

  /**
   * Retorna una instancia de un tramite por default.
   *
   * @param {number} idTramite
   * @returns {Observable<Tramite>}
   * @memberof FlowService
   */
  getInstance(idTramite: number): Promise<Tramite> {

    return new Promise((resolve, reject) => {
      this.http.get<Tramite>(this.api.get('instanceTramite', [idTramite])).subscribe(
        data => {
          resolve(data);
        },
        err => {
          reject(err);
        }
      );
    });
  }

 /**
  * Finaliza una tarea que funciones con el endpoint 'instanceMethods'.
  *
  * @param {ConfigFinishDefault} config
  * @returns {Promise<boolean>}
  * @memberof TaskService
  */
  finishDefault(config: ConfigFinishDefault): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http
        .post(this.api.get('instanceMethods'), config, {
          observe: 'response'
        })
        .subscribe(
          res => {
            if (res.status === 200) {
              resolve(true);
              this.toastr.success(`La liquidacion se guardó correctamente.`, 'Operación exitosa');
            } else {
              resolve(false);
            }
          },
          err => {
            resolve(false);
            reject(err);
          }
        );
    });
  }

  /**
  * Obtiene los datos adicionales de la tarea
  *
  * @param {number} idTask
  * @returns {Promise<boolean>}
  * @memberof TaskService
  */
  getInstancePrincipalTask(idTask: number): Promise<TareaInstance> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler()
      .get<TareaInstance>(this.api.get('instanceTask', [idTask])).subscribe(
        task => {
          resolve(task);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/forms/all/instance-liquidation/load-task/shared/load-task.data.service.ts